import React, {Component} from 'react';
import "./MySpinner.css";



export default class MySpinner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name:props.name

    }

  }

  render() {

    return (
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    )

  }
}
